export default "__VITE_ASSET__CdVpEK1r__"